import { render, staticRenderFns } from "./CheckoutPaket.vue?vue&type=template&id=2251799e&"
import script from "./CheckoutPaket.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports